"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _MarkdownHelp = require("./MarkdownHelp");

var _MarkdownHelp2 = _interopRequireDefault(_MarkdownHelp);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubmitPage = function SubmitPage(_ref) {
  var _ref$MarkdownHelp = _ref.MarkdownHelp,
      MarkdownHelp = _ref$MarkdownHelp === undefined ? _MarkdownHelp2.default : _ref$MarkdownHelp,
      _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link,
      subreddit = _ref.subreddit,
      _ref$siteprefix = _ref.siteprefix,
      siteprefix = _ref$siteprefix === undefined ? "r" : _ref$siteprefix,
      _ref$sitename = _ref.sitename,
      sitename = _ref$sitename === undefined ? "reddit" : _ref$sitename,
      _ref$subname = _ref.subname,
      subname = _ref$subname === undefined ? "subreddit" : _ref$subname,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? "" : _ref$title,
      _ref$url = _ref.url,
      url = _ref$url === undefined ? "" : _ref$url,
      _ref$text = _ref.text,
      text = _ref$text === undefined ? "" : _ref$text,
      _ref$is_self = _ref.is_self,
      is_self = _ref$is_self === undefined ? false : _ref$is_self,
      _ref$isShowingMarkdow = _ref.isShowingMarkdownHelp,
      isShowingMarkdownHelp = _ref$isShowingMarkdow === undefined ? false : _ref$isShowingMarkdow,
      contentPolicyUrl = _ref.contentPolicyUrl,
      reddiquetteUrl = _ref.reddiquetteUrl,
      _ref$reddiquetteName = _ref.reddiquetteName,
      reddiquetteName = _ref$reddiquetteName === undefined ? "reddiquette" : _ref$reddiquetteName,
      subscribedSubreddits = _ref.subscribedSubreddits,
      urlError = _ref.urlError,
      titleError = _ref.titleError,
      textError = _ref.textError,
      subredditError = _ref.subredditError,
      onChangeIsSelf = _ref.onChangeIsSelf,
      onChangeTitle = _ref.onChangeTitle,
      onChangeUrl = _ref.onChangeUrl,
      onChangeText = _ref.onChangeText,
      onChangeSubreddit = _ref.onChangeSubreddit,
      onChangeSendReplies = _ref.onChangeSendReplies,
      onSuggestTitle = _ref.onSuggestTitle,
      onSubmit = _ref.onSubmit;
  return _react2.default.createElement(
    "div",
    { className: "content", role: "main" },
    _react2.default.createElement(
      "h1",
      null,
      "submit to ",
      subreddit ? _react2.default.createElement(
        "a",
        { href: "/" + siteprefix + "/" + subreddit + "/" },
        subreddit
      ) : sitename
    ),
    _react2.default.createElement(
      "form",
      {
        className: "submit content warn-on-unload",
        id: "newlink",
        method: "post",
        onSubmit: onSubmit
      },
      _react2.default.createElement("input", { name: "uh", type: "hidden", defaultValue: "AaronSw" }),
      _react2.default.createElement(
        "ul",
        { className: "tabmenu formtab" },
        _react2.default.createElement(
          "li",
          { className: is_self ? "" : "selected" },
          _react2.default.createElement(
            "a",
            {
              className: "link-button choice",
              href: "",
              onClick: function onClick(e) {
                e.preventDefault();
                return onChangeIsSelf && onChangeIsSelf(false);
              }
            },
            "link"
          )
        ),
        _react2.default.createElement(
          "li",
          { className: is_self ? "selected" : "" },
          _react2.default.createElement(
            "a",
            {
              className: "link-button choice",
              href: "",
              onClick: function onClick(e) {
                e.preventDefault();
                return onChangeIsSelf && onChangeIsSelf(true);
              }
            },
            "text"
          )
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "formtabs-content" },
        _react2.default.createElement(
          "div",
          { className: "spacer" },
          is_self ? _react2.default.createElement(
            "div",
            {
              className: "infobar",
              id: "text-desc"
            },
            "You are submitting a text-based post. Speak your mind. A title is required, but expanding further in the text field is not. Beginning your title with \"vote up if\" is violation of intergalactic law."
          ) : _react2.default.createElement(
            "div",
            {
              className: "infobar",
              id: "link-desc"
            },
            "You are submitting a link. The key to a successful submission is interesting content and a descriptive title."
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "spacer" },
          _react2.default.createElement(
            "div",
            { className: "roundfield", id: "title-field" },
            _react2.default.createElement(
              "span",
              { className: "title" },
              "title"
            ),
            _react2.default.createElement(
              "div",
              { className: "roundfield-content" },
              _react2.default.createElement("textarea", {
                name: "title",
                required: true,
                rows: 2,
                defaultValue: title,
                onChange: onChangeTitle
              }),
              titleError ? _react2.default.createElement(
                "div",
                { className: "error field-title" },
                titleError
              ) : null
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "spacer" },
          _react2.default.createElement(
            "div",
            {
              className: "roundfield",
              id: "url-field",
              style: { display: is_self ? "none" : "block" }
            },
            _react2.default.createElement(
              "span",
              { className: "title" },
              "url"
            ),
            _react2.default.createElement(
              "div",
              { className: "roundfield-content" },
              _react2.default.createElement("input", {
                disabled: is_self ? "disabled" : null,
                name: "kind",
                type: "hidden",
                defaultValue: "link"
              }),
              _react2.default.createElement("input", {
                disabled: is_self ? "disabled" : null,
                id: "url",
                name: "url",
                required: true,
                type: "url",
                defaultValue: url,
                onChange: onChangeUrl
              }),
              urlError ? _react2.default.createElement(
                "div",
                { className: "error field-url" },
                urlError
              ) : null,
              _react2.default.createElement("div", { className: "error ALREADY_SUB field-url", style: { display: "none" } }),
              onSuggestTitle ? _react2.default.createElement(
                "div",
                { id: "suggest-title" },
                _react2.default.createElement(
                  "button",
                  { tabIndex: 100, type: "button" },
                  "suggest title"
                )
              ) : null
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "spacer" },
          _react2.default.createElement(
            "div",
            {
              className: "roundfield",
              id: "text-field",
              style: { display: is_self ? "block" : "none" }
            },
            _react2.default.createElement(
              "span",
              { className: "title" },
              "text"
            ),
            " ",
            _react2.default.createElement(
              "span",
              { className: "little gray roundfield-description" },
              "(optional)"
            ),
            _react2.default.createElement(
              "div",
              { className: "roundfield-content" },
              _react2.default.createElement("input", { name: "kind", type: "hidden", defaultValue: "self" }),
              _react2.default.createElement(
                "div",
                { className: "usertext" },
                _react2.default.createElement("input", { name: "thing_id", type: "hidden", defaultValue: true }),
                _react2.default.createElement(
                  "div",
                  { className: "usertext-edit md-container", style: {} },
                  _react2.default.createElement(
                    "div",
                    { className: "md" },
                    _react2.default.createElement("textarea", {
                      cols: 1,
                      name: "text",
                      defaultValue: text,
                      onChange: onChangeText,
                      rows: 1,
                      disabled: is_self ? null : "disabled"
                    })
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "bottom-area" },
                    _react2.default.createElement(
                      "span",
                      { className: "help-toggle toggle", style: {} },
                      _react2.default.createElement(
                        "a",
                        { className: "option active", tabIndex: 100 },
                        "formatting help"
                      ),
                      _react2.default.createElement(
                        "a",
                        { className: "option" },
                        "hide help"
                      )
                    ),
                    _react2.default.createElement(
                      "a",
                      {
                        className: "reddiquette",
                        href: "/help/contentpolicy",
                        tabIndex: 100,
                        target: "_blank"
                      },
                      "content policy"
                    ),
                    textError ? _react2.default.createElement(
                      "div",
                      { className: "error field-text" },
                      textError
                    ) : null,
                    _react2.default.createElement(
                      "div",
                      { className: "usertext-buttons" },
                      _react2.default.createElement(
                        "button",
                        {
                          className: "save",
                          style: { display: "none" },
                          type: "submit"
                        },
                        "save"
                      ),
                      _react2.default.createElement(
                        "button",
                        {
                          className: "cancel",
                          style: { display: "none" },
                          type: "button"
                        },
                        "cancel"
                      )
                    )
                  ),
                  isShowingMarkdownHelp ? _react2.default.createElement(MarkdownHelp, null) : null
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "spacer" },
          _react2.default.createElement(
            "div",
            { className: "roundfield", id: "reddit-field" },
            _react2.default.createElement(
              "span",
              { className: "title" },
              "choose a ",
              subname
            ),
            _react2.default.createElement(
              "div",
              { className: "roundfield-content" },
              _react2.default.createElement(
                "div",
                { id: "sr-autocomplete-area" },
                _react2.default.createElement("input", {
                  autoComplete: "off",
                  id: "sr-autocomplete",
                  name: "sr",
                  required: true,
                  type: "text",
                  defaultValue: subreddit,
                  onChange: onChangeSubreddit
                }),
                _react2.default.createElement(
                  "ul",
                  { id: "sr-drop-down" },
                  _react2.default.createElement(
                    "li",
                    { className: "sr-name-row" },
                    "nothin"
                  )
                )
              ),
              subredditError ? _react2.default.createElement(
                "div",
                { className: "error field-sr" },
                subredditError
              ) : null,
              subscribedSubreddits ? _react2.default.createElement(
                "div",
                { id: "suggested-reddits" },
                _react2.default.createElement(
                  "h3",
                  null,
                  "your subscribed subs"
                ),
                _react2.default.createElement(
                  "ul",
                  null,
                  subscribedSubreddits.map(function (name, idx) {
                    return _react2.default.createElement(
                      "li",
                      { key: name },
                      _react2.default.createElement(
                        "a",
                        { tabIndex: 100 + idx },
                        sitename
                      )
                    );
                  })
                )
              ) : null
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "spacer" },
          _react2.default.createElement(
            "div",
            { className: "submit_text roundfield" },
            _react2.default.createElement(
              "h1",
              null,
              "submitting to /",
              siteprefix,
              "/",
              subreddit
            )
          )
        ),
        onChangeSendReplies ? _react2.default.createElement(
          "div",
          { className: "spacer" },
          _react2.default.createElement(
            "div",
            { className: "roundfield" },
            _react2.default.createElement(
              "span",
              { className: "title" },
              "options"
            ),
            _react2.default.createElement(
              "div",
              { className: "roundfield-content" },
              _react2.default.createElement("input", {
                defaultChecked: "checked",
                className: "nomargin",
                "data-send-checked": "true",
                id: "sendreplies",
                name: "sendreplies",
                type: "checkbox",
                onChange: onChangeSendReplies
              }),
              _react2.default.createElement(
                "label",
                { htmlFor: "sendreplies" },
                "send replies to my inbox"
              )
            )
          )
        ) : null
      ),
      contentPolicyUrl || reddiquetteUrl ? _react2.default.createElement(
        "div",
        { className: "roundfield info-notice" },
        contentPolicyUrl ? _react2.default.createElement(
          _react.Fragment,
          null,
          "please be mindful of ",
          sitename,
          "'s",
          " ",
          _react2.default.createElement(
            Link,
            { href: "/help/contentpolicy", target: "_blank" },
            "content policy"
          )
        ) : null,
        reddiquetteUrl ? _react2.default.createElement(
          _react.Fragment,
          null,
          " and practice ",
          _react2.default.createElement(
            Link,
            { href: reddiquetteUrl, target: "_blank" },
            "good ",
            reddiquetteName
          ),
          "."
        ) : null
      ) : null,
      _react2.default.createElement("input", { name: "resubmit", type: "hidden", defaultValue: true }),
      _react2.default.createElement(
        "div",
        { className: "spacer" },
        _react2.default.createElement(
          "button",
          { className: "btn", name: "submit", type: "submit", value: "form" },
          "submit"
        )
      )
    )
  );
};

exports.default = SubmitPage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/SubmitPage.js
// module id = 738
// module chunks = 0